import axios from 'axios'
import env from '../env'

export default class RecommendApi {
  /**
   * 获取手机装修的关联数据
   * @param params array 关联id列表
   * @returns
   */
  static async getMobileTemplateData (params: {
    array: string[];
  }) {
    const Url: string = `${env.JMOBILE}/mobileHomePage/getMobileTemplateData`
    const res: any = await axios.post(Url, params)
    return res.error ? res : res.result
  }
}
